export default __webpack_public_path__ + "static/media/guest_12_01_priscylla.446a5afe.png";